import { retry } from '@repo/ts-query-utils/retry'
import { retryDelay } from '@repo/ts-query-utils/retry-delay'
import * as Sentry from '@sentry/browser'
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { isError, isNetworkError } from 'utils/js'
import { reportAppRendererNetworkError } from './desktop/app-renderer-online'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError(error, query) {
      if (isNetworkError(error)) {
        reportAppRendererNetworkError()
      }
      Sentry.addBreadcrumb({
        category: 'query.error',
        level: 'warning',
        message: String(query.queryHash),
        data: {
          queryHash: query.queryHash,
          fetchFailureCount: query.state.fetchFailureCount,
          observers: query.getObserversCount(),
          message: error instanceof Error ? error.message : String(error),
        },
      })
    },
  }),
  mutationCache: new MutationCache({
    onError(error) {
      if (isNetworkError(error)) {
        reportAppRendererNetworkError()
      }
    },
  }),
  defaultOptions: {
    queries: {
      retry,
      retryDelay,
    },
    mutations: {
      onError(error, _variables, context) {
        if (isNetworkError(error)) {
          return
        }

        if (isError(error) && !String(error.message)?.startsWith('CF_')) {
          // eslint-disable-next-line no-console
          console.error(error, context)
        }
      },
    },
  },
})
